// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"2f81357a","264":"a7cc60ab","521":"e406cb4b","803":"371065f8","854":"55d1da1d","864":"a09ac78c","998":"9f8322dc"}[chunkId] + ".chunk.js";
};